import Modal from "./Modal";
const WithModal =
  (WrappedComponent) =>
  ({ open, title, handleClose, ...otherProps }) =>
    (
      <Modal open={open} title={title} handleClose={handleClose}>
        <WrappedComponent handleClose={handleClose} {...otherProps} />
      </Modal>
    );

export default WithModal;
